// src/auth/guards.jsx
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { isAuthed } from "./session";

// Only allow when authenticated
export function RequireAuth({ children }) {
  const loc = useLocation();
  if (!isAuthed()) {
    return <Navigate to={`/login?next=${encodeURIComponent(loc.pathname + loc.search)}`} replace />;
  }
  return children;
}

// If already authed, bounce away from login/register
export function RedirectIfAuthed({ to = "/account", children }) {
  if (isAuthed()) return <Navigate to={to} replace />;
  return children;
}
